import classNames from 'classnames'
import { useState } from 'react'

// Domains
import { ProductSizeGuide } from '../SizeGuide.types'

// Components
import SizeChart from '../../sizeChart'
import MeasuringGuide from '../../sizeChart/components/measuringGuide/MeasuringGuide'
import Tabs, { Tab } from '../../tabs'

// Styles
import styles from './sizeGuideOne.module.scss'

interface SizeGuideOneProps {
  wrapperClassName?: string
  productSizeGuides: ProductSizeGuide[]
  activeSizeGuideUnitIndex: number
}

enum TAB_STATES {
  SIZE_CHART = 'SIZE_CHART',
  MEASURING_GUIDE = 'MEASURING_GUIDE',
}

const SizeGuideOne = (props: SizeGuideOneProps) => {
  const [activeTabId, setActiveTabId] = useState(TAB_STATES.SIZE_CHART)
  return (
    <div className={classNames(props.wrapperClassName, styles.sizeGuideOne)}>
      <Tabs
        activeTabId={TAB_STATES[activeTabId]}
        onChange={activeId => {
          setActiveTabId(activeId as TAB_STATES)
        }}
        className={styles.sizeGuideOne_tabsContainer}
        tabButtonWrapperClassname={styles.sizeGuideTabsContainer__tabButtonWrapper}
        activeTabHeaderClassName={styles.sizeGuideTabsContainer__tabHeader__active}
      >
        <Tab
          id={TAB_STATES.SIZE_CHART}
          title={'Size Chart'}
          headerClassName={styles.sizeGuideTabsContainer__tabHeader}
          panelClassName={styles.sizeGuideTabsContainer__tabContent}
        >
          <SizeChart
            productSizeGuides={props.productSizeGuides}
            activeSizeGuideUnitIndex={props.activeSizeGuideUnitIndex}
          />
        </Tab>

        <Tab
          id={TAB_STATES.MEASURING_GUIDE}
          title={'Measuring Guide'}
          headerClassName={styles.sizeGuideTabsContainer__tabHeader}
          panelClassName={styles.sizeGuideTabsContainer__tabContent}
        >
          {props.productSizeGuides[0].measuringGuide && (
            <MeasuringGuide measuringGuide={props.productSizeGuides[0].measuringGuide} />
          )}
        </Tab>
      </Tabs>
    </div>
  )
}

export default SizeGuideOne
